export default __webpack_public_path__ + "static/media/mobile_slider.fec3fe29.MP4";